import { Check, Minus } from 'lucide-react';

interface ApprovalRequiredCellProps {
  isApprovalRequired: boolean;
}

export const ApprovalRequiredCell = ({ isApprovalRequired }: ApprovalRequiredCellProps) => {
  if (isApprovalRequired) {
    return <Check className="h-4 w-4 text-success" />;
  }

  return <Minus className="h-4 w-4 text-muted-foreground" />;
};
